const POSITIONS = {
  tl: "top-3 left-3",
  tr: "top-3 right-3",
  bl: "bottom-3 left-3",
  br: "bottom-3 right-3",
};

export const Ladybug = ({ size = 22, rotate = 0, className = "", spot }) => (
  <span
    aria-hidden="true"
    data-testid="ladybug"
    className={`ladybug inline-block pointer-events-auto ${spot ? `absolute z-10 ${POSITIONS[spot]}` : ""} ${className}`}
    style={{ "--r": `${rotate}deg`, width: size, height: size }}
  >
    <svg viewBox="0 0 40 40" width={size} height={size}>
      <path d="M14 9 L10 3 M26 9 L30 3" stroke="#2f5a1f" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M8 18 L2 15 M8 25 L2 27 M32 18 L38 15 M32 25 L38 27" stroke="#2f5a1f" strokeWidth="1.4" strokeLinecap="round" />
      <ellipse cx="20" cy="11" rx="7" ry="5" fill="#2f5a1f" />
      <ellipse cx="20" cy="23" rx="12.5" ry="13" fill="#7fbf4d" stroke="#3f7a2a" strokeWidth="1.2" />
      <path d="M20 10.5 V36" stroke="#2f5a1f" strokeWidth="1.3" />
      <circle cx="14" cy="19" r="2.4" fill="#2f5a1f" />
      <circle cx="26" cy="19" r="2.4" fill="#2f5a1f" />
      <circle cx="13.5" cy="28" r="2.1" fill="#2f5a1f" />
      <circle cx="26.5" cy="28" r="2.1" fill="#2f5a1f" />
      <ellipse cx="15" cy="16" rx="3" ry="1.6" fill="#ffffff" opacity=".35" />
    </svg>
  </span>
);
